/* eslint-disable @nx/enforce-module-boundaries */
import { FC } from "react";

import { CMSBlock } from "@tudigo-monorepo/core-tudigo-api-models";
import {
  AnalyzeBlock,
  AudioBlock,
  ButtonBlock,
  CardEventBlock,
  CardPressCoverageBlock,
  CardsBlock,
  CarouselBlock,
  ChronologyBlock,
  FrequentlyAskedQuestionBlock,
  GalleryBlock,
  HeadingBlock,
  HighlightBlock,
  HtmlBlock,
  IFrameBlock,
  ImageAndTextBlock,
  ImageBlock,
  ListBlock,
  MosaicGalleryBlock,
  ParagraphBlock,
  PodcastCarouselBlock,
  QuotesBlock,
  TableBlock,
  VideoBlock,
} from "@tudigo-monorepo/web-tudigo-editor";

export const getArticleComponentByCMSBlock = (block: CMSBlock): FC => {
  switch (block.type) {
    // Text blocks
    case "heading":
      return () => <HeadingBlock block={block} />;
    case "paragraph":
      return () => <ParagraphBlock block={block} />;
    case "list":
      return () => <ListBlock block={block} />;
    case "html":
      return () => <HtmlBlock block={block} />;
    case "table":
      return () => <TableBlock block={block} />;

    // Media blocks
    case "images":
      return () => <ImageBlock block={block} />;
    case "image-and-text":
      return () => <ImageAndTextBlock block={block} />;
    case "video":
      return () => <VideoBlock block={block} />;
    case "audio":
      return () => <AudioBlock block={block} />;
    case "iframe":
      return () => <IFrameBlock block={block} />;
    case "gallery":
      return () => <GalleryBlock block={block} />;
    case "mosaic-gallery":
      return () => <MosaicGalleryBlock block={block} />;
    case "carousel":
      return () => <CarouselBlock block={block} />;

    // Card blocks
    case "cards-quote":
      return () => <QuotesBlock block={block} />;
    case "cards-text-with-image":
      return () => <CardsBlock block={block} />;
    case "card-event":
      return () => <CardEventBlock block={block} />;
    case "card-press-coverage":
      return () => <CardPressCoverageBlock block={block} />;
    case "podcast-carousel":
      return () => <PodcastCarouselBlock block={block} />;

    // Interactive blocks
    case "button":
      return () => <ButtonBlock block={block} />;
    case "faq-block":
      return () => <FrequentlyAskedQuestionBlock block={block} />;

    // Special blocks
    case "chronology":
      return () => <ChronologyBlock block={block} />;
    case "analyze":
      return () => <AnalyzeBlock block={block} />;
    case "highlight":
      return () => <HighlightBlock block={block} />;
    default:
      // Log unsupported block types silently in production
      if (process.env.NODE_ENV !== "production") {
        // eslint-disable-next-line no-console
        console.warn(`Unsupported block type: ${block.type}`, block);
      }

      return () => null;
  }
};
